import { useEffect, useState } from "react";
import { _Entailment, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { _CloseProvisions, _CreateProvision, _ExportProvision, _Provision, _ProvisionCatalogData, _ProvisionData } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { InputDate } from "../../../theme/Input/InputDate";
import { FileService } from "../../../../core/services/FileService";
import { VisorAnyDocument } from "../../../documents/VisorAnyDocument";
import { AccountantYear } from "../../GestionTH/EmployeeContract/ProductionPlan/AccountantYear";
import { MonthConstantsEditor } from "../../../RemoteAbstractAction/editors/MonthConstantsEditor";
import usePaginator from "../../../theme/Component/usePaginator";
import { DocumentHeaderByProcess } from "./DocumentHeaderByProcess/DocumentHeaderByProcess";
import { ProvisionCatalogByData } from "./ProvisionCatalogByData";
import { MonthEditorbyconst } from "../../../RemoteAbstractAction/editors/MonthEditorbyconst";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { useQueueProvider } from "../../../theme/Component/ValidationDocumentQueue/QueueProvider";


export const ProvisionData = () => {

    const { addProcess } = useQueueProvider();

    const provnew = useDataBean(_ProvisionData);
    const Provision = useDataBean(_Provision);
    const createprov = useDataBean(_CreateProvision);
    const exportprov = useDataBean(_ExportProvision);
    const prvdata = useDataBean(_ProvisionCatalogData);
    const close = useDataBean(_CloseProvisions);
    const [form, setForm] = useState<any>({
        Year: _single.getCurrenYear(),
        Month: _single.getCurrentMonth(),
        recalculateProvisions: false,
        adjustAccountantBook: false,
        closeProvisionsForYear: false
    });
    const fileService = new FileService();
    const single = Singleton.getInstance();
    const paginador = usePaginator();
    const [procces, setProcces] = useState<any>(null)
    const [queue, setQueue] = useState<any>(null)
    const [formato, setFormato] = useState<any>(null)
    const [type, settype] = useState<any>([]);
    const [lista, setLista] = useState<any>([]);
    const [Year, setYear] = useState<number>(_single.getCurrenYear())
    const [Month, setMonth] = useState<number>(_single.getCurrentMonth())
    const [date, setDate] = useState<any>(_single.getCurrenDate());
    const [modalrever, setModalrever] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });
    const [modaltwo, setModaltwo] = useState<any>({ view: false, btnClose: true, btnSubmit: true, format: 'modal-sm', name: "Generar Provisiones" });

    const [modalviewdoc, setModalviewdoc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modalviewdoctree, setModalviewdoctree] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });
    const [modalviewdocfour, setModalviewdocfour] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });
    const [modalviewdoctwo, setModalviewdoctwo] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalconsult, setModalconsult] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modaldoc, setModaldoc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        provnew.instance.getProvisionDataCatalog(Year, Month, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    // paginador.setPages(resp.NumberOfPages);
                    // paginador.setRecords(resp.NumberOfPages * (15));
                    // paginador.setRegiPerPage(15)
                    // setLista(resp.List)
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    let tmp = resp.List;
                    tmp.forEach((element: any) => {
                        if (element.DataBeanProperties.MediaContext) {
                            element.DataBeanProperties.URL = ` <a href="${fileService.getUrlFile(element.DataBeanProperties.MediaContext, element.DataBeanProperties.Media)}" target='_blank'>DESCARGAR DOCUMENTO</a>`
                        } else {
                            element.DataBeanProperties.URL = "Sin Documento";
                        }
                    });
                    setLista(tmp);
                } else {
                    setLista([]);
                }
            }
        )

    }

    const create = () => {
        provnew.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        provnew.deleteItemVoid(provnew.bean.IDProvisionData).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )
    }

    const editaItem = () => {
        //console.log(entailment.bean);
        provnew.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDProvisionData', visible: true },
        { title: 'Vigencia', property: 'Year', visible: true },
        { title: 'Mes', property: 'MonthName', visible: true },
        { title: 'Tipo', property: 'TypeName', visible: true },
        { title: 'Subtipo', property: 'SubtypeName', visible: true },
        { title: 'Estado', property: 'StateName', visible: true },
        { title: 'Provisiones Recalculadas', property: 'RecalculateProvisions', visible: true },
        { title: 'Ajuste de Libro Contable', property: 'AdjustAccountantBook', visible: true },
        { title: 'Total Provisiones', property: 'TotalTaskCount', visible: true },
        { title: 'Total Procesado', property: 'TotalTaskProcessed', visible: true },
        { title: 'ID Proceso', property: 'IDProcess', visible: true },
        { title: 'Fecha de Proceso', property: 'ProcessDate', visible: true },
        { title: 'Empleado', property: 'EmployeeName', visible: true },
        // { title: 'Ver / Descargar Reporte', property: 'URL', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            // { titulo: 'Descargar Reporte', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModaldescarga({ ...modaldescarga, "view": true }) } },
            { titulo: 'Documentos del Proceso', icono: 'ri-file-search-line', visible: single.canEdit(), evento: () => { setModaldoc({ ...modaldoc, "view": true }) } },
            { titulo: 'Generar Informe de Provisiones', icono: 'ri-file-download-line', visible: single.canEdit(), evento: () => { exportProvisionsSpreadSheettwo() } },
            { titulo: 'Contabilizar Provisiones', icono: 'ri-file-chart-line', visible: single.canEdit(), evento: () => { createProvisionAccounting() } },
            { titulo: 'Consultar Provisiones', icono: 'ri-file-unknow-fill', visible: single.canEdit(), evento: () => { setModalconsult({ ...modalconsult, "view": true }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    const ver = () => {

        setModal({ ...modal, "view": true });

    }
    const getFileType = (mediaName: string) => {
        let fileType = mediaName.split('.').pop()?.toLowerCase();
        return fileType;
    }
    const exportProvisionsSpreadSheet = () => {

        Provision.instance.exportProvisionsSpreadSheet(date, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    setModal({ ...modal, "view": false });
                    // setModalviewdoc({ ...modalviewdoc, "view": true });
                    if (resp.length == 1) {
                        setProcces(resp[0].DataBeanProperties)
                        addProcess(resp[0].DataBeanProperties.IDProcessQueue)
                    }
                }
            }
        )

    }

    const exportProvisionsSpreadSheettwo = () => {

        exportprov.instance.exportProvisionsSpreadSheet(provnew.bean.IDProvisionData, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    console.log(resp)
                    // setModalviewdoctwo({ ...modalviewdoctwo, "view": true });
                    if (resp.length == 1) {
                        setQueue(resp[0].DataBeanProperties)
                        addProcess(resp[0].DataBeanProperties.IDProcessQueue)
                    }
                }
            }
        )

    }
    const createProvisionAccounting = () => {

        createprov.instance.createProvisionAccounting(provnew.bean.IDProvisionData, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    console.log(resp)
                    getLista()
                }
            }
        )

    }

    const vertwo = () => {
        setForm({
            Year: _single.getCurrenYear(),
            Month: _single.getCurrentMonth(),
            recalculateProvisions: false,
            adjustAccountantBook: false,
            vacationDays: 22
        })
        setModaltwo({ ...modaltwo, "view": true });
    }

    const verrever = () => {
        setModalrever({ ...modalrever, "view": true });
    }

    const createProvisions = () => {

        prvdata.instance.createProvisions(form.Year, form.Month, _single.getAccountID(), form.recalculateProvisions, form.adjustAccountantBook, form.vacationDays).then(
            (resp: any) => {
                if (resp) {
                    console.log(resp)
                    setModaltwo({ ...modaltwo, "view": false });
                    getLista()
                }
            }
        ).catch(err => { toast.error(err) })

    }
    const closeProvisions = () => {

        close.instance.closeProvisions(form.Year, form.Month, _single.getAccountID(), form.closeProvisionsForYear).then(
            (resp: any) => {
                if (resp) {
                    console.log(resp)
                    setModalrever({ ...modalrever, "view": false });
                    getLista()
                }
            }
        )

    }
    return (
        <BasicPage titulo="Reporte de Provisiones">
            <div className="row">
                <div className="col-md-4">
                    <AccountantYear idSelector={Year} onChange={(e: any) => { setYear(e) }} />
                </div>
                <div className="col-md-4 p-3">
                    <MonthConstantsEditor idSelect={Month} onChange={(e: any) => { setMonth(e) }} />
                </div>
                <div className="col-md-4 mt-4 p-2">
                    <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-4">
                    <BasicButton icon="ri-file-download-fill" eventClick={ver}>Descargar Reporte</BasicButton>
                </div>
                <div className="col-md-4">
                    <BasicButton icon="ri-align-justify" eventClick={vertwo}>Generar Provisiones Mensuales</BasicButton>
                </div>
                <div className="col-md-4">
                    <BasicButton icon="ri-folder-received-fill" eventClick={verrever}>Reversar Provisiones de Contratos Liquidados</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={provnew.setBean} listButtons={listaBotones()} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={exportProvisionsSpreadSheet}>
                        <div className="row">
                            <div className="col-md-12">
                                <InputDate label="Fecha de Corte" name="Desde" value={date} setDate={(e: any) => { setDate(e) }} ></InputDate>
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modaltwo} updateModal={setModaltwo} eventModal={createProvisions}>
                        <div className="row">
                            <div className="col-md-12">
                                <AccountantYear idSelector={form.Year} onChange={(e) => { setForm({ ...form, "Year": e }) }} />
                            </div>
                            <div className="col-md-12">
                                <MonthEditorbyconst idSelector={form.Month} onChange={(e) => { setForm({ ...form, "Month": e }) }} />
                            </div>
                            <div className="col-md-12">
                                <BasicSwitch label="Recalcular Provisiones" estado={form.recalculateProvisions} eventChange={(e) => { setForm({ ...form, "recalculateProvisions": e }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Días de Vacaciones</label>
                                <input type="number" className="form-control" value={form.vacationDays} onChange={(e) => {
                                    const valor = e.target.value ? parseInt(e.target.value) : null
                                    setForm({ ...form, vacationDays: valor })
                                }} />
                            </div>
                            <div className="col-md-12">
                                <BasicSwitch label="Ajustar Libro Contable" estado={form.adjustAccountantBook} eventChange={(e) => { setForm({ ...form, "adjustAccountantBook": e }) }} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalrever} updateModal={setModalrever} eventModal={closeProvisions}>
                        <div className="row">
                            <div className="col-md-12">
                                <AccountantYear idSelector={form.Year} onChange={(e) => { setForm({ ...form, "Year": e }) }} />
                            </div>
                            <div className="col-md-12">
                                <MonthEditorbyconst idSelector={form.Month} onChange={(e) => { setForm({ ...form, "Month": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="Reversar Provisiones Vigencia" estado={form.closeProvisionsForYear} eventChange={(e) => { setForm({ ...form, "closeProvisionsForYear": e }) }} />
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalconsult} updateModal={setModalconsult}>
                        <div className="row">
                            <div className="col-md-12">
                                <ProvisionCatalogByData idProvisionData={provnew.bean.IDProvisionData} />
                            </div>
                        </div>
                    </Modal>
                    {/* <Modal modal={modalviewdoc} updateModal={setModalviewdoc}>
                        <div className="row">
                            <div className="col-md-12">
                                <ValidationDocumentQueue idprocessqueue={procces?.IDProcessQueue} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalviewdoctwo} updateModal={setModalviewdoctwo}>
                        <div className="row">
                            <div className="col-md-12">
                                <ValidationDocumentQueue idprocessqueue={queue?.IDProcessQueue} />
                            </div>
                        </div>
                    </Modal> */}
                    <Modal modal={modalviewdoctree} updateModal={setModalviewdoctree}>
                        <div className="row">
                            <div className="col-md-12">
                                <VisorAnyDocument url={formato} type={type} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalviewdocfour} updateModal={setModalviewdocfour}>
                        <div className="row">
                            <div className="col-md-12">
                                <VisorAnyDocument url={formato} type={type} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modaldoc} updateModal={setModaldoc}>
                        <div className="row">
                            <div className="col-md-12">
                                <DocumentHeaderByProcess idProcess={provnew.bean.IDProcess} year={provnew.bean.Year} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {provnew.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}